import React, { useState } from "react";
import {
  LineChart,
  Line,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  XAxis,
} from "recharts";
import { Card } from "antd";
import Dropdown from "./dropdown";
import moment from "moment";

const HomeGraphCard = ({ setFilter, graphData, week }) => {
  const dropdownData = [
    {
      _id: 1,
      name: "weekly",
    },
    {
      _id: 2,
      name: "monthly",
    },
  ];
  return (
    <Card className="m-2 p-1 shadow-md">
      <div className="flex">
        <ResponsiveContainer width="80%" height={300}>
          <LineChart
            width={500}
            height={300}
            data={graphData}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="date" axisLine={false} tick={null} />
            {/* <YAxis /> */}
            <Tooltip formatter={(value) => value?.toFixed(2)} />
            {/* <Legend /> */}
            <Line
              type="monotone"
              dataKey="payout"
              stroke="#F6A903"
              strokeWidth={2}
              activeDot={{ r: 8 }}
            />
            <Line
              type="monotone"
              strokeWidth={2}
              dataKey="revenue"
              stroke="#8884d8"
            />
          </LineChart>
        </ResponsiveContainer>
        <div className="mt-2">
          <Dropdown
            className={"w-20"}
            data={dropdownData}
            defaultValue={week}
            onChange={(e) => {
              setFilter(dropdownData[e - 1]?.name);
            }}
          />
          <div className="flex items-center mt-1">
            <div className="w-1 h-1 border border-2 border-solid border-primaryOrange rounded-full mt-1.5" />
            <p className="text-primaryOrange font-medium ml-1 mb-0">
              business payout
            </p>
          </div>
          <div className="flex items-center">
            <div className="w-1 h-1 border border-2 border-solid border-primaryPurple rounded-full mt-1.5" />
            <p className="text-primaryPurple font-medium ml-1 mb-0">
              gross revenue
            </p>
          </div>
        </div>
      </div>
      {graphData && (
        <p className="mt-0 mb-0 font-medium	 opacity-60">
          {moment(graphData[0]?.date).format("MMM DD YYYY")} -{" "}
          {moment(graphData[graphData?.length - 1]?.date).format("MMM DD YYYY")}
        </p>
      )}
    </Card>
  );
};

export default HomeGraphCard;
